function setFromBazaar(value) {
    return {
        type: 'SET_FROM_BAZAAR',
        payload: value
    };
}

export { setFromBazaar };
